export default __webpack_public_path__ + "static/media/three_tou1.f3038a73.png";